import { createSelector } from 'reselect'

const earnOffersManagementState = (state) => state.earnOffersManagement

export const getData = createSelector(
  earnOffersManagementState,
  (state) => state?.data || []
)

export const getIsLoaded = createSelector(
  earnOffersManagementState,
  (state) => state?.isLoaded || false
)

export const getPage = createSelector(
  earnOffersManagementState,
  (state) => state?.page || 1
)

export const getPageCount = createSelector(
  earnOffersManagementState,
  (state) => state?.pageCount || 1
)

export const getTotal = createSelector(
  earnOffersManagementState,
  (state) => state?.total || 0
)

export const getPerPage = createSelector(
  earnOffersManagementState,
  (state) => state?.perPage || 50
)

export const getSearch = createSelector(
  earnOffersManagementState,
  (state) => state?.search || ''
)

export const getNetwork = createSelector(
  earnOffersManagementState,
  (state) => state?.network || ''
)

export const getProgramStatus = createSelector(
  earnOffersManagementState,
  (state) => state?.programStatus || ''
)

export const getApprovalStatus = createSelector(
  earnOffersManagementState,
  (state) => state?.approvalStatus || ''
)

export const getSort = createSelector(
  earnOffersManagementState,
  (state) => state?.sort || ''
)

export const getActiveTab = createSelector(
  earnOffersManagementState,
  (state) => state?.activeTab || 'game'
)

export const getSelectedRowKeys = createSelector(
  earnOffersManagementState,
  (state) => state?.selectedRowKeys || []
)

export const getIsBulkActionLoading = createSelector(
  earnOffersManagementState,
  (state) => state?.isBulkActionLoading || false
)

export const getNetworks = createSelector(
  earnOffersManagementState,
  (state) => state?.networks || []
)

export const getGameGenres = createSelector(
  earnOffersManagementState,
  (state) => state?.gameGenres || []
)

export const getProgramDetail = createSelector(
  earnOffersManagementState,
  (state) => state?.programDetail || null
)

export const getIsProgramLoading = createSelector(
  earnOffersManagementState,
  (state) => state?.isProgramLoading || false
)

export const getIsProgramSaving = createSelector(
  earnOffersManagementState,
  (state) => state?.isProgramSaving || false
)

export const getGoalDetail = createSelector(
  earnOffersManagementState,
  (state) => state?.goalDetail || null
)

export const getIsGoalLoading = createSelector(
  earnOffersManagementState,
  (state) => state?.isGoalLoading || false
)

export const getIsGoalSaving = createSelector(
  earnOffersManagementState,
  (state) => state?.isGoalSaving || false
)

export const getIsFeatureSaving = createSelector(
  earnOffersManagementState,
  (state) => state?.isFeatureSaving || false
)

export const getProgramRowById = createSelector(
  getData,
  (data) => (id) => data.find((row) => row.id === id) || null
)
